// Progress Chart
document.addEventListener('DOMContentLoaded', function () {
    const progressChartElement = document.getElementById('progressChart');

    if (!progressChartElement) return;

    const ctx = progressChartElement.getContext('2d');

    // Funktion zum Prüfen des aktuellen Themes


    // Daten aus dem data-Attribut lesen
    const results = JSON.parse(progressChartElement.dataset.results || '[]');

    // Einheiten-Nummern für die X-Achse
    const unitNumbers = Array.from({ length: 12 }, (_, i) => i + 1);

    // Daten für die Linien
    const datasets = [
        {
            label: 'Schmerzbeeinträchtigung',
            data: unitNumbers.map(unit => {
                const result = results.find(r => r.unit_id === unit);
                return result ? result.beeintraechtigung : null;
            }),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
            tension: 0.4,
            fill: false
        },
        {
            label: 'Stimmung',
            data: unitNumbers.map(unit => {
                const result = results.find(r => r.unit_id === unit);
                return result ? result.verstimmung : null;
            }),
            borderColor: 'rgb(54, 162, 235)',
            backgroundColor: 'rgba(54, 162, 235, 0.5)',
            tension: 0.4,
            fill: false
        },
        {
            label: 'Aktivitätslevel',
            data: unitNumbers.map(unit => {
                const result = results.find(r => r.unit_id === unit);
                return result ? result.gesamtaktivitaet : null;
            }),
            borderColor: 'rgb(75, 192, 192)',
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            tension: 0.4,
            fill: false
        }
    ];

    // Initiale Theme-Farben
    const isDark = isDarkMode();
    const textColor = isDark ? '#e1e1e1' : '#3b3b3b';
    const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

    // Chart erstellen
    const progressChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: unitNumbers.map(unit => `Einheit ${unit}`),
            datasets: datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: textColor
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    backgroundColor: isDark ? 'rgba(50, 50, 50, 0.9)' : 'rgba(255, 255, 255, 0.9)',
                    titleColor: isDark ? '#ffffff' : '#000000',
                    bodyColor: isDark ? '#e1e1e1' : '#3b3b3b',
                    borderColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
                    borderWidth: 1,
                    padding: 12,
                    cornerRadius: 6
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: 'Wert',
                        color: textColor
                    },
                    grid: {
                        color: gridColor
                    },
                    ticks: {
                        color: textColor
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: 'Einheit',
                        color: textColor
                    },
                    grid: {
                        color: gridColor
                    },
                    ticks: {
                        color: textColor
                    }
                }
            }
        }
    });

    function isDarkMode() {
        return document.documentElement.getAttribute('data-bs-theme') === 'dark';
    }

    // Funktion zum Aktualisieren der Chart-Farben
    function updateChartColors(chart) {
        const isDark = isDarkMode();
        const textColor = isDark ? '#e1e1e1' : '#3b3b3b';
        const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

        // Update Chart-Optionen
        chart.options.scales.x.grid.color = gridColor;
        chart.options.scales.y.grid.color = gridColor;
        chart.options.scales.x.ticks.color = textColor;
        chart.options.scales.y.ticks.color = textColor;
        chart.options.scales.x.title.color = textColor;
        chart.options.scales.y.title.color = textColor;
        chart.options.plugins.legend.labels.color = textColor;

        // Update Tooltip-Farben
        chart.options.plugins.tooltip.backgroundColor = isDark ? 'rgba(50, 50, 50, 0.9)' : 'rgba(255, 255, 255, 0.9)';
        chart.options.plugins.tooltip.titleColor = isDark ? '#ffffff' : '#000000';
        chart.options.plugins.tooltip.bodyColor = isDark ? '#e1e1e1' : '#3b3b3b';
        chart.options.plugins.tooltip.borderColor = isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)';

        chart.update();
    }

    // Theme-Wechsel-Listener
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'data-bs-theme') {
                updateChartColors(progressChart);
            }
        });
    });

    observer.observe(document.documentElement, {
        attributes: true
    });
});
